import React from "react";
import { Route, Switch } from "react-router-dom";
import styled from "styled-components";
import ContactForm from "../pages/contact/contact";
import { Home } from "../pages/home/home";

export const MainLayout= () => {
  // const classes = useStyles();

  // const location = useLocation();
  // const pathName = location.pathname;



  const MainDiv = styled.div`
  width: 100%;
  -webkit-box-align: center;
  top: 118px;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: overlay;
  position: relative;
}
  `;
 
const MiddleSectionDiv = styled.div`
max-width: 1200px;
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 71px;
    
`




  return (
    <>
      <MainDiv>
     
      <MiddleSectionDiv>
      <div style={{marginBottom:'5%'}}>
      <span className={'gradient1-text'} style={{fontSize:65}}>CSV FILE HANDLER</span><br/>
      <span className={'gradient1-text'} style={{fontSize: 34}}>Convert your csv to json </span>
      </div>
     
      <Switch>
      <Route path={`/contact`} exact={true}>
              <div style={{background:`var('--color-text') !important`}}><ContactForm /></div>
              
              </Route>
              <Route path={`/`} exact={true}>
                <div style={{background:`var('--color-text') !important`}}><Home /></div>
              </Route>
             
             
            </Switch>
     
   
      </MiddleSectionDiv>
            
         
      </MainDiv>
    </>
  );
};
